exports = module.exports = require("../../../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._32pqwYCzct6NdmPqDs66ds ._2iK3dfq_4qyvrl5KCESE6g .qKNXNnXGUF7I5YX9Tt4xD{display:block;position:absolute;left:0;top:0;box-sizing:border-box}", ""]);
// Exports
exports.locals = {
	"monaco-editor": "_32pqwYCzct6NdmPqDs66ds",
	"view-overlays": "_2iK3dfq_4qyvrl5KCESE6g",
	"current-line": "qKNXNnXGUF7I5YX9Tt4xD"
};